import React from 'react';
import { cn } from '@utils/index';
import { HEALTH_HUB_CONTACT_SECTIONS } from '../constants/health-hub-contacts';

const contactLinkClassName =
  'font-bold text-primary underline decoration-primary/30 underline-offset-2';

const providerLabelClassName = 'font-bold text-gray-500';

type HealthHubContactSectionsProps = {
  showTitles?: boolean;
  className?: string;
  itemClassName?: string;
  textClassName?: string;
  titleClassName?: string;
};

export const HealthHubContactSections = ({
  showTitles = true,
  className,
  itemClassName,
  textClassName = 'text-base max-1xl:text-sm text-gray-600 leading-snug',
  titleClassName =
    'text-base max-1xl:text-sm font-extrabold uppercase tracking-wide text-gray-500 mb-2',
}: HealthHubContactSectionsProps) => {
  return (
    <div className={cn('flex flex-col', className)}>
      {HEALTH_HUB_CONTACT_SECTIONS.map((section, index) => (
        <div
          key={section.id}
          className={cn(
            'py-3 first:pt-0 last:pb-0',
            index > 0 && 'border-t border-[#E5E2DC]',
            itemClassName
          )}
        >
          {showTitles && (
            <h3 className={titleClassName}>{section.title}</h3>
          )}
          <p className={textClassName}>
            {section.bodyPrefix}{' '}
            <span className={providerLabelClassName}>{section.providerLabel}</span>{' '}
            <a href={section.phoneHref} className={contactLinkClassName}>
              {section.phone}
            </a>
            {section.hours ? <> {section.hours}</> : null}
            {section.email && section.emailHref ? (
              <>
                {' '}
                or email{' '}
                <a href={section.emailHref} className={contactLinkClassName}>
                  {section.email}
                </a>
              </>
            ) : null}
          </p>
        </div>
      ))}
    </div>
  );
};
